import React from 'react'
import { Document, Page, View, Text, Image, StyleSheet } from '@react-pdf/renderer'

export type QrStickerPdfItem = {
  code: string
  /** data:image/...;base64,... */
  imageDataUrl: string
}

const COLS = 3
const ROWS = 4
export const QR_STICKERS_PER_PAGE = COLS * ROWS

const styles = StyleSheet.create({
  page: {
    paddingTop: 18,
    paddingBottom: 18,
    paddingHorizontal: 22,
    backgroundColor: '#ffffff',
  },
  grid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  cell: {
    width: '33.333%',
    height: 180,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 6,
  },
  qr: {
    width: 130,
    height: 130,
  },
  code: {
    marginTop: 6,
    fontSize: 8,
    fontFamily: 'Courier',
    letterSpacing: 0.6,
    color: '#111111',
  },
})

function chunk<T>(arr: T[], size: number): T[][] {
  const out: T[][] = []
  for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size))
  return out
}

export function QrStickerBatchPdf({ items }: { items: QrStickerPdfItem[] }) {
  const pages = chunk(items, QR_STICKERS_PER_PAGE)
  return (
    <Document>
      {pages.map((pageItems, pageIdx) => (
        <Page key={pageIdx} size="LETTER" style={styles.page}>
          <View style={styles.grid}>
            {pageItems.map((item) => (
              <View key={item.code} style={styles.cell} wrap={false}>
                <Image src={item.imageDataUrl} style={styles.qr} />
                <Text style={styles.code}>{item.code}</Text>
              </View>
            ))}
          </View>
        </Page>
      ))}
    </Document>
  )
}

export default QrStickerBatchPdf
